import { createContext, type PropsWithChildren } from "react";
import useComment from "./useComment";
import type { CommentProviderProps } from "./types";

export const CommentContext = createContext({} as ReturnType<typeof useComment>);

const CommentProvider = ({ children, ...restProps }: PropsWithChildren<CommentProviderProps>) => (
    <CommentContext.Provider
        value={useComment(restProps)}
    >
        {children}
    </CommentContext.Provider>
);

export default CommentProvider;
